import { LitElement } from '@lit'

class NovaPrice extends LitElement {
  connectedCallback() {
    super.connectedCallback()
    this.updateContent = this.updateContent.bind(this)
    document.addEventListener('nova:product:render-price', this.updateContent)
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    document.removeEventListener(
      'nova:product:render-price',
      this.updateContent,
    )
  }

  updateContent(event) {
    const content = event.detail.html
    if (!content) return
    this.innerHTML = content.innerHTML
  }

  createRenderRoot() {
    return this
  }
}

customElements.define('nova-price', NovaPrice)
